/**
 * @generated SignedSource<<9c8d8fb725fae31a097ded301234677e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AtlassianProductsFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string | null;
    readonly node: {
      readonly id: string;
      readonly productId: string;
      readonly title: string | null;
      readonly type: string | null;
      readonly viewHref: string | null;
    } | null;
  } | null> | null;
  readonly totalCount: number | null;
  readonly " $fragmentType": "AtlassianProductsFragment";
};
export type AtlassianProductsFragment$key = {
  readonly " $data"?: AtlassianProductsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AtlassianProductsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AtlassianProductsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedAtlassianProductEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedAtlassianProduct",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewHref",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "UnifiedAtlassianProductConnection",
  "abstractKey": null
};

(node as any).hash = "79dd56a563d72ba8b81c879718b3bfcd";

export default node;
